<template>
  <div class="apply-refund">
    <div class="refund-detail">
      <p class="order-num">订单编号 Order number：{{ refundInfo.orderGoodsNo }}</p>
      <div class="order-good">
        <img class="img-url" :src="refundInfo.coverImage"/>
        <div class="title">
          <p>{{ refundInfo.name }}</p>
          <p>{{ refundInfo.nameEn }}</p>
          <p>规格：{{ refundInfo.spec || "单规格" }}</p>
        </div>
        <div class="price">￥{{ refundInfo.price }}×{{ refundInfo.qty }}</div>
      </div>
    </div>
    <div class="refund-able">
      <div class="able-box">
        <div class="title">
          <span>请选择申请退款的商品 Please select the item for refund</span>
          <span v-if="goodList.length">（{{ goodList.length }}件可退 {{ goodList.length }} items are refundable）</span>
        </div>
        <div class="price">
          <span>已选{{ checkedGoods.length }}件</span>
          <span>退款金额：￥{{ totalAmount }}</span>
        </div>
      </div>
      <div class="able-list">
        <el-checkbox-group v-model="checkedGoods">
          <el-checkbox v-for="item in goodList"
                       :key="item.orderGoodsDetailNo"
                       :label="item.orderGoodsDetailNo"
                       :disabled="item.orderGoodsDetailStatusNoIs">
            <span>{{ item.name }}</span>
            <span>{{ item.orderGoodsDetailStatusNotag }}</span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="able-reason">
      <p class="reason-title">请选择申请原因 Please select the reason for application</p>
      <el-checkbox-group v-model="checkedReasons">
        <el-checkbox v-for="data in reasonList" @change="handleCheckedReasonsChange(data.value)" :label="data.value"
                     :key="data.value"
        >{{ data.chName }} {{ data.enName }}
        </el-checkbox
        >
      </el-checkbox-group>
    </div>
    <div class="fill-notes">
      <p>请填写补充说明（选填）Please fill in the supplementary notes (optional)</p>
      <el-input class="ainput-number" v-model="textareaInput" type="textarea"></el-input>
    </div>
    <div class="upload-image">
      <UploadImage v-model="images" ref="uploadImage" :limit="5" :multiple="true" description="上传凭证"
                   maximumUpload="（最多5张）"/>
    </div>
    <el-button type="primary" class="Submit" @click="doRefundOrder">提交 Submit</el-button>
  </div>
</template>

<script>
import UploadImage from "@/components/base/UploadImage";

export default {
  name: "ApplyRefund",
  components: {UploadImage},
  data() {
    return {
      refundInfo: {}, //退款信息
      account: "", //退款金额
      buyCount: 1,
      checked: false,
      checkedReasons: [],
      reasonList: [
        {
          value: 1,
          chName: "质量问题",
          enName: "Quality problem",
        },
        {
          value: 2,
          chName: "商品错发/漏发",
          enName: "Wrong/missing shipment of goods",
        },
        {
          value: 3,
          chName: "显示签收实际收到商品",
          enName: "Show receipt of goods actually received",
        },
        {
          value: 4,
          chName: "提货缺货",
          enName: "Pick-up and out-of-stock",
        },
        {
          value: 5,
          chName: "其他",
          enName: "Other",
        },
      ],
      goodList: [], //商品列表
      checkedGoods: [],
      textareaInput: "",
      images: "",
      status: {0: "未出货", 1: "已出货", 2: "未退款", 3: "已退款"},
    };
  },
  props: {},
  computed: {
    totalAmount() {
      let total = 0n
      this.checkedGoods.forEach(ele => {
        let product = this.goodList.find(p => p.orderGoodsDetailNo == ele)
        if (product != undefined) {
          let payAmount = product.payAmount
          total += BigInt(payAmount);
        }
      })
      total = total.toString()
      if (total == 0) {
        return `0.00`
      }
      return `${total.slice(0, total.length - 2)}.${total.slice(total.length - 2)}`;
    }
  },
  async mounted() {
    let obj = this.$route.query;
    this.getOrderRefundInfo(obj.id);
  },
  methods: {
    handleCheckedReasonsChange(value) {
      this.checkedReasons = [];
      this.$set(this.checkedReasons, 0, value);
    },
    async getOrderRefundInfo(id) {
      const params = {
        orderNo: id,
      };
      let {data} = await this.$api.getOrderRefundInfo(params);
      this.refundInfo = data;
      let account = await this.getAccount();
      this.account = account;
      this.goodList = (data.detailVOList || []).map((item) => {
        item.orderGoodsDetailStatusNoIs = item.orderGoodsDetailStatus == 0 && item.refundOrderId;
        item.orderGoodsDetailStatusNotag = this.status[item.orderGoodsDetailStatus];
        return item;
      });
    },
    async getAccount() {
      let {refundAmountList} = this.refundInfo;
      let value = this.buyCount;
      let account = 0;
      for (let i = 0; i < value; i++) {
        account += refundAmountList[i];
      }
      return account;
    },
    async doRefundOrder() {
      if (this.checkedGoods.length == 0) {
        this.$message.error("请选择申请退款的商品");
        return;
      }
      if (this.checkedReasons.length == 0) {
        this.$message.error("请选择退款原因");
        return;
      }
      const params = {
        images: this.images,
        orderDetailNos: this.checkedGoods,
        reason: this.checkedReasons[0],
        remark: this.textareaInput,
      };
      await this.$api.doRefundOrder(params);
      this.$router.push("/my-profile/after-sales");
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.apply-refund {
  margin-top: 30px;

  .refund-detail {
    width: 100%;
    height: 194px;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    padding: 30px;
    box-sizing: border-box;

    .order-num {
      font-size: 14px;

      font-weight: 400;
      color: #333333;
    }

    .order-good {
      margin-top: 31px;
      display: flex;

      .img-url {
        width: 88px;
        height: 88px;
      }

      .title {
        margin-left: 20px;

        p {
          font-size: 14px;

          font-weight: 400;

          &:nth-child(1) {
            color: #333333;
          }

          &:nth-child(2) {
            color: #333333;
            margin-top: 4px;
          }

          &:nth-child(3) {
            color: #999999;
            margin-top: 19px;
          }
        }
      }

      .price {
        margin-left: 250px;
      }
    }
  }

  .refund-able {
    margin-top: 60px;
    border-bottom: 1px solid #f0f0f0;

    .able-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        span {
          font-size: 18px;

          &:nth-child(1) {
            font-weight: bold;
            color: #333333;
          }

          &:nth-child(2) {
            color: #999999;
          }
        }
      }

      .price {
        span {
          font-size: 14px;

          font-weight: 400;
          color: #333333;

          &:nth-child(2) {
            padding-left: 19px;
          }
        }
      }
    }

    .able-list {
      margin-top: 29px;

      span {
        font-size: 14px;

        font-weight: 400;

        &:nth-child(1) {
          color: #333333;
          padding-right: 98px;
        }

        &:nth-child(2) {
          color: #999999;
        }
      }
    }
  }

  .able-reason {
    margin-top: 30px;
    border-bottom: 1px solid #f0f0f0;

    .reason-title {
      margin-bottom: 29px;
    }
  }

  .fill-notes {
    margin: 30px 0 60px 0;
  }

  .Submit {
    margin: 60px 0;
    width: 240px;
    height: 60px;
    background: #333333;
  }
}

/deep/ .el-checkbox {
  margin-bottom: 28px;
  margin-right: 98px;
}

/deep/ .el-textarea .el-textarea__inner {
  width: 800px;
  height: 160px;
  margin-top: 29px;
  resize: none;
}

/deep/ .el-checkbox-group {
  display: flex;
  flex-direction: column;
  font-size: 14px;

  font-weight: 400;
  color: #333333;
}
</style>
